import { permissionMapping } from './permissionMapping';
import { IconsFolderL1, IconsSubFolder, UserProfilePageRefs } from '../types';
import { UserRole } from '../types';

const { userProfilePagesVisibility } = permissionMapping.user;

interface MenuItem {
  name: UserProfilePageRefs;
  icon: {
    folder: IconsFolderL1;
    subFolder: IconsSubFolder;
  };
  href: string;

  // only applicable when another user is viewing the profile page, in my account all pages are available to the
  // authenticated user
  requiredRoles: Array<UserRole>;
}

const userProfileMenuItems: Array<MenuItem> = [
  {
    name: 'personal_details',
    icon: {
      folder: 'my-account',
      subFolder: '01-personal-details',
    },
    href: 'personal',
    requiredRoles: userProfilePagesVisibility['personal_details'],
  },
  {
    name: 'login_security',
    icon: {
      folder: 'my-account',
      subFolder: '02-login-and-security',
    },
    href: 'login',
    requiredRoles: userProfilePagesVisibility['login_security'],
  },
  {
    name: 'notifications_preferences',
    icon: {
      folder: 'system',
      subFolder: '05-notifications',
    },
    href: 'notifications',
    requiredRoles: userProfilePagesVisibility['notifications_preferences'],
  },
  {
    name: 'global_preferences',
    icon: {
      folder: 'system',
      subFolder: '11-settings',
    },
    href: 'global',
    requiredRoles: userProfilePagesVisibility['global_preferences'],
  },
];

export { userProfileMenuItems, MenuItem };
